export interface BaseRequest {
  apiVersion: number;
  apiVersionMinor: number;
}
export const baseRequest: BaseRequest = {
  apiVersion: 2,
  apiVersionMinor: 0,
};
